"use client";

import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
export default function Footer() {
  return <footer className="border-t border-white/5 bg-[#171717] py-20 text-white">
      <div className="container mx-auto max-w-7xl px-4">
        <div className="flex flex-col items-start justify-between gap-12 text-left md:flex-row md:gap-6">
          <div className="max-w-[280px] space-y-6">
            <img src="https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/Adsiz-tasarim-4-1.png" alt="Mona Spor" className="h-12 w-auto opacity-90" />

            <p className="text-[11px] uppercase leading-relaxed tracking-[0.18em] text-gray-500">
              Высококлассная реабилитация
              <br />
              и спортивная терапия
              <br />
              <span className="text-gray-400">Alanya, Turkey</span>
            </p>
          </div>

          <div className="min-w-[150px] space-y-6">
            <h3 className="text-xs font-semibold uppercase tracking-[0.28em] text-[#166534]">
              Меню
            </h3>

            <ul className="space-y-3 text-[12px] uppercase tracking-[0.14em] text-gray-400">
              <li>
                <a href="#программы" className="transition-colors hover:text-white">
                  Программы
                </a>
              </li>
              <li>
                <a href="#локации" className="transition-colors hover:text-white">
                  Локации
                </a>
              </li>
              <li>
                <a href="#галерея" className="transition-colors hover:text-white">
                  Галерея
                </a>
              </li>
              <li>
                <a href="#услуги" className="transition-colors hover:text-white">
                  Услуги
                </a>
              </li>
              <li>
                <a href="#о-нас" className="transition-colors hover:text-white">
                  О нас
                </a>
              </li>
            </ul>
          </div>

          <div className="min-w-[220px] space-y-6">
            <h3 className="text-xs font-semibold uppercase tracking-[0.28em] text-[#166534]">
              Связь
            </h3>

            <ul className="space-y-4 text-[12px] text-gray-400">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 size-4 shrink-0 text-[#166534]" />
                <span className="leading-tight">
                  Kestel Mah., Toklar Cad., 7/A
                </span>
              </li>

              <li className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-[#166534]" />
                <span>+90 546 516 68 07</span>
              </li>

              <li className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-[#166534]" />
                <span className="truncate">monaspor07@gmail.com</span>
              </li>
            </ul>
          </div>

          <div className="min-w-[200px] space-y-6 opacity-90">
            <h3 className="text-xs font-semibold uppercase tracking-[0.28em] text-[#166534]">
              График
            </h3>

            <div className="space-y-3 text-[11px] uppercase tracking-[0.14em]">
              <div className="flex justify-between border-b border-white/5 pb-2">
                <span className="mr-8 text-gray-500">Пн — Пт</span>
                <span className="text-gray-300">09:00 – 17:00</span>
              </div>

              <div className="flex justify-between border-b border-white/5 pb-2">
                <span className="mr-8 text-gray-500">Суббота</span>
                <span className="text-gray-300">09:00 – 14:00</span>
              </div>

              <div className="text-[10px] text-gray-600">
                Воскресенье — выходной
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 flex items-center justify-between border-t border-white/5 pt-8 text-[10px] uppercase tracking-[0.22em] text-gray-600">
          <span>© 2026 Mona Spor Kulübü. Все права защищены.</span>
        </div>
      </div>
    </footer>;
}